import gql from "graphql-tag";
const getUtilityFunctionsQuery = gql(` 
query getUtilityFunctions($event: AWSJSON!) {
  getUtilityFunctions(event: $event) {
    result
    error
  }
}
`)
export default getUtilityFunctionsQuery;
